import { Routes } from '@angular/router';

export const content: Routes = [
  {
    path: 'user',
    data: {
      title: 'user.users',
      breadcrumb: 'user.users'
    },
    loadChildren: () => import('../../components/users/users.routes')
  },
  {
    path: 'role',
    data: {
      title: 'role.roles',
      breadcrumb: 'role.roles'
    },
    loadChildren: () => import('../../components/roles/role.routes')
  },
  {
    path: 'test-form',
    data: {
      title: 'Test Form',
      breadcrumb: 'Test Form'
    },
    loadComponent: () =>
      import('../../components/test-form/test-form.component').then((m) => m.TestFormComponent)
  },
  {
    path: 'test-table',
    data: {
      title: 'Test Table',
      breadcrumb: 'Test Table'
    },
    loadComponent: () =>
      import('../../components/test-table/test-table.component').then((m) => m.TestTableComponent)
  },
  {
    path: 'impostazioni',
    data: {
      title: 'Impostazioni',
      breadcrumb: 'Impostazioni'
    },
    loadComponent: () =>
      import('../../components/settings/my-profiles/my-profile.component').then(
        (m) => m.MyProfileComponent
      )
  }
];
